import axios from "axios";
import { useAuth } from "./auth.service";

const API_BASE_URL = process.env.REACT_APP_BACKEND_API;

export const useAseguradosService = () => {
  const { user } = useAuth();

  const getAuthHeaders = () => ({
    "Content-Type": "application/json",
    "x-access-token": user?.accessToken,
  });

  // Get all asegurados with pagination
  const getAsegurados = async (skip = 0, limit = 20, search = "") => {
    try {
      console.log('Fetching asegurados with:', { skip, limit, search }); // Debug log
      const response = await axios.get(
        `${API_BASE_URL}/asegurados?skip=${skip}&limit=${limit}&search=${search}`,
        { headers: getAuthHeaders() }
      );
      console.log('API Response:', response.data); // Debug log
      return response.data;
    } catch (error) {
      console.error("Error fetching asegurados:", error);
      if (error.response) {
        console.error("Error response:", error.response.data);
      }
      throw error;
    }
  };

  // Get specific asegurado
  const getAsegurado = async (celular) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/asegurados/${celular}`,
        { headers: getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching asegurado:", error);
      throw error;
    }
  };

  // Create new asegurado
  const createAsegurado = async (aseguradoData) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/asegurados`,
        aseguradoData,
        { headers: getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error("Error creating asegurado:", error);
      throw error;
    }
  };

  // Update asegurado
  const updateAsegurado = async (celular, updateData) => {
    try {
      const response = await axios.put(
        `${API_BASE_URL}/asegurados/${celular}`,
        updateData,
        { headers: getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error("Error updating asegurado:", error);
      throw error;
    }
  };

  // Block asegurado
  const blockAsegurado = async (celular, bloqueado) => {
    try {
      const response = await axios.patch(
        `${API_BASE_URL}/asegurados/${celular}/block`,
        { bloqueado },
        { headers: getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error("Error blocking asegurado:", error);
      throw error;
    }
  };

  // Get statistics
  const getStatsOverview = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/asegurados/stats/overview`,
        { headers: getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching stats overview:", error);
      throw error;
    }
  };

  const getStatsExecutives = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/asegurados/stats/executives`,
        { headers: getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching executives stats:", error);
      throw error;
    }
  };

  const getStatsTags = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/asegurados/stats/tags`,
        { headers: getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching tags stats:", error);
      throw error;
    }
  };

  // Export to Excel
  const exportToExcel = async (filters = {}) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/asegurados/export`,
        { filters },
        { 
          headers: getAuthHeaders(),
          responseType: 'blob'
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error exporting to Excel:", error);
      throw error;
    }
  };

  return {
    getAsegurados,
    getAsegurado,
    createAsegurado,
    updateAsegurado,
    blockAsegurado,
    getStatsOverview,
    getStatsExecutives,
    getStatsTags,
    exportToExcel,
  };
}; 